import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-content-unlocked-modal',
  standalone: false,
  templateUrl: './content-unlocked-modal.component.html',
  styleUrl: './content-unlocked-modal.component.scss',
})
export class ContentUnlockedModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
 
  @Input() trainingsCount = 0;
  @Input() categoriesCount = 0;
 
  @Output() continue = new EventEmitter<void>();
 
  onContinue(): void {
    this.continue.emit();
    this.close();
  }
 
  private close(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
